import * as MODULES from '../module-constants.json';

const MAP_DEFAULTS = {
   zoom: themeSettings.map && themeSettings.map.zoom
      ? parseInt(themeSettings.map.zoom)
      : 8,
   lightness: themeSettings.map && themeSettings.map.lightness
      ? parseInt(themeSettings.map.lightness)
      : -15,
   color: themeSettings.map && themeSettings.map.color
      ? themeSettings.map.color
      : undefined,
};


export function initMap(){
	if (typeof _moduleJs === 'undefined') {
		return;
	}
	let mapModules = _moduleJs.filter(
		m => m.type === 'VENUE'
	);
	if (mapModules.length){
		mapModules.forEach(m => {
			let el = document.querySelector(`#${m.id} .evtx-gmap`);
			if (el){
				buildMap(el, m.options.address, m.options);
			}
		});
	}
}

export function buildMap(element, address, options={}){
   var geocoder = new google.maps.Geocoder();
   geocoder.geocode({ address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
			return;
		}
		var map = new google.maps.Map(element, {
			zoom: parseInt(options.zoom || MAP_DEFAULTS.zoom),
			scrollwheel: false,
			center: results[0].geometry.location,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					stylers: [
						{ hue: options.color
							|| MAP_DEFAULTS.color },
						// { saturation: 0 },
						{ lightness: parseInt(options.lightness
							|| MAP_DEFAULTS.lightness) },
					],
				},
				{
					featureType: "road",
					elementType: "geometry",
					stylers: [
						{ lightness: 100 },
						{ visibility: "simplified" },
					],
				},
				{
					featureType: "road",
					elementType: "labels",
					stylers: [
						{ visibility: "off" },
					],
				},
				{
					featureType: "water",
					elementType: "geometry",
					stylers: [
						{ lightness: 100 },
					],
				},
			],
		});

		var marker = new google.maps.Marker({
			map,
			position: results[0].geometry.location,
		});
   });
}